
/*
import { ref } from "vue"
// API Location
let API_URL =
  window.location.hostname === 'app.lwyr.ca'
    ? 'https://api.lwyr.ca'
    //: 'http://localhost:3000'
    :`http://${window.location.hostname}:3000`



export const isAdmin = ref(false)

export async function checkAdmin(auth) {
  const user = auth.currentUser
  if (!user) return

  const token = await user.getIdToken()

  const res = await fetch(`${API_URL}/api/check-admin`, {
    headers: { Authorization: `Bearer ${token}` }
  })

  const data = await res.json()
  isAdmin.value = !!data.isAdmin
}
*/

import { ref } from "vue"
import { onAuthStateChanged } from "firebase/auth"


// API Location
let API_URL =
  window.location.hostname === 'app.lwyr.ca'
    ? 'https://api.lwyr.ca'
    //: 'http://localhost:3000'
    :`http://${window.location.hostname}:3000`



export const isAdmin = ref(false)
export async function checkAdmin(auth) {
  return new Promise((resolve) => {
    onAuthStateChanged(auth, async (user) => {
      if (!user) {
        isAdmin.value = false
        return resolve()
      }

      const token = await user.getIdToken()

      const res = await fetch(`${API_URL}/api/check-admin`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      const data = await res.json()
      isAdmin.value = !!data.isAdmin

      resolve()
    })
  })
}
